import React, { useEffect, useRef, useState } from 'react';
import './header.css';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/Logo.svg';
import hamburger from '../../../assets/images/hamburger.svg';
import SideMenu from '../sideMenu/sideMenu';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, origin } = location;
  const [menuShow, setMenuShow] = useState(false);
  useEffect(() => {
    window.scroll(0, 0);
    setPageTitle();
  }, []);

  function setPageTitle() {
    switch (pathname) {
      case '/':
        document.title = 'FinGate.io';
        break;
      case '/products/sc':
      case '/products/cc':
      case '/products/ewa':
      case '/products/pp':
        document.title = 'FinGate.io - Ürünler';
        break;
      case '/reference':
        document.title = 'FinGate.io - Referanslar';
        break;
      case '/about':
        document.title = 'FinGate.io - Hakkımızda';
        break;
      case '/contact':
        document.title = 'FinGate.io - İletişim';
        break;
      default:
        document.title = 'FinGate.io';
    }
  }
  function handleNavigate(path) {
    navigate(path);
  }
  const [productsMenuOpen, setProductsMenuOpen] = useState(false);
  return (
    <div className="header-main">
      <div className="header-cont">
        <div onClick={() => handleNavigate('/')} className="c-pointer">
          <img alt="logo" src={logo} className="header-logo" />
        </div>
        <div className="header-pages">
          <div
            style={{ position: 'relative' }}
            className={`m-r-24 c-pointer ${pathname.includes('/products') && ' selected'}`}
            onMouseEnter={() => setProductsMenuOpen(true)}
            onMouseLeave={() => setProductsMenuOpen(false)}
          >
            ÜRÜNLER
            <div className={`${productsMenuOpen ? 'd-flex' : 'd-none'} header-dropdown-menu`}>
              <div className="header-dropdown-menu-item">
                <div
                  onClick={() => handleNavigate('/products/sc')}
                  className={`m-t-8 ${pathname === '/products/sc' && ' selected'}`}
                >
                  Alışveriş Kredisi
                </div>
                {/* <div */}
                {/*  onClick={() => handleNavigate('/products/cc')} */}
                {/*  className={`m-t-8 ${pathname === '/products/cc' && ' selected'}`} */}
                {/* > */}
                {/*  Ticari Kredi */}
                {/* </div> */}
                <div
                  onClick={() => { window.open('https://kolayavans.com'); }}
                  className={`m-t-8 ${pathname === '/products/ewa' && ' selected'}`}
                >
                  Kolay Avans
                </div>
                <div
                  onClick={() => handleNavigate('/products/pp')}
                  className={`m-t-8 ${pathname === '/products/pp' && ' selected'}`}
                >
                  ParaPlus
                </div>
              </div>
            </div>
          </div>
          <div className={`m-r-24 c-pointer ${pathname === '/reference' && ' selected'}`} onClick={() => handleNavigate('/reference')}>
            REFERANSLAR
          </div>
          <div className={`m-r-24 c-pointer ${pathname === '/about' && ' selected'}`} onClick={() => handleNavigate('/about')}>
            HAKKIMIZDA
          </div>
          <div className={`c-pointer ${pathname === '/contact' && ' selected'}`} onClick={() => handleNavigate('/contact')}>
            İLETİŞİM
          </div>
          <div className="demo" onClick={() => handleNavigate('/demo')}>
            DEMO TALEBİ
          </div>
        </div>
        <div className="hamburger-button" onClick={() => setMenuShow(!menuShow)}>
          <img alt="sideMenu" src={hamburger} />
        </div>
        <SideMenu show={menuShow} toggle={(e) => setMenuShow(e)}>
          <div className="side-cont">
            <div className={`side-button ${pathname === '/' && ' selected'}`} onClick={() => handleNavigate('/')}>
              ANASAYFA
            </div>
            <div
              className={`side-button text-right ${pathname.includes('/products') && ' selected'}`}
            >
              ÜRÜNLER
              <div className="header-dropdown-menu-item-mobile">
                <div
                  onClick={() => handleNavigate('/products/sc')}
                  className={`m-t-8 ${pathname === '/products/sc' && ' selected'}`}
                >
                  Alışveriş Kredisi
                </div>
                {/* <div */}
                {/*  onClick={() => handleNavigate('/products/cc')} */}
                {/*  className={`m-t-8 ${pathname === '/products/cc' && ' selected'}`} */}
                {/* > */}
                {/*  Ticari Kredi */}
                {/* </div> */}
                <div
                  onClick={() => { window.open('https://kolayavans.com'); }}
                  className={`m-t-8 ${pathname === '/products/ewa' && ' selected'}`}
                >
                  Kolay Avans
                </div>
                <div
                  onClick={() => handleNavigate('/products/pp')}
                  className={`m-t-8 ${pathname === '/products/pp' && ' selected'}`}
                >
                  ParaPlus
                </div>
              </div>
            </div>
            <div
              className={`side-button ${pathname === '/reference' && ' selected'}`}
              onClick={() => handleNavigate('/reference')}
            >
              REFERANSLAR
            </div>
            <div
              className={`side-button ${pathname === '/about' && ' selected'}`}
              onClick={() => handleNavigate('/about')}
            >
              HAKKIMIZDA
            </div>
            <div
              className={`side-button ${pathname === '/contact' && ' selected'}`}
              onClick={() => handleNavigate('/contact')}
            >
              İLETİŞİM
            </div>
            <div className="demo" onClick={() => handleNavigate('/demo')}>
              DEMO TALEBİ
            </div>
          </div>
        </SideMenu>
      </div>
    </div>
  );
}

export default Header;
